import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { PortalHeader } from '@cca/ui';

export function AuthLayout({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--paper)',
      }}
    >
      <PortalHeader portalName="Parish Portal" />
      <div
        style={{ flex: 1, maxWidth: 768, margin: '0 auto', width: '100%', padding: '40px 24px' }}
      >
        {children}
      </div>
      <footer
        style={{
          borderTop: '1px solid var(--border)',
          background: '#fff',
          padding: '14px 0',
          textAlign: 'center',
          fontSize: 11,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          color: 'var(--text2)',
        }}
      >
        CCAANZ Parish Portal · {new Date().getFullYear()} ·{' '}
        <Link to="/privacy" style={{ color: 'var(--text2)', textDecoration: 'underline' }}>
          Privacy
        </Link>
      </footer>
    </div>
  );
}
